import React, { useState } from "react";
import logo from "../../assets/logo.png"; // <-- Add your logo here
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";


const DashboardCard = ({ title, value, subvalue, highlight, isDark }) => {
  // Helper: parse amount after 'Potential Value:' and return discounted amount (80%) or null
  const parseAndDiscount = (text) => {
    if (!text) return null;
    const marker = 'Potential Value:';
    const idx = text.indexOf(marker);
    if (idx === -1) return null;
    const amountPart = text.slice(idx + marker.length).trim();
    const numeric = parseFloat(amountPart.replace(/[^0-9.-]+/g, ''));
    if (isNaN(numeric)) return null;
    const discounted = numeric * 0.8; // deduct 20%
    return discounted;
  };

  const discountedAmount = parseAndDiscount(subvalue);

  return (
    <div
      className={`${isDark ? 'bg-dark text-white border-white' : 'bg-white  text-dark border-white'} h-100 p-3 rounded border d-flex flex-column align-items-center justify-content-center text-center`}
      style={{
        minHeight: '120px',
        backgroundColor: isDark ? '#000' : '#fff',
        borderWidth: '10px'
      }}
    >
      <div className="text-uppercase fw-semibold text-truncate text-uppercase mb-2" style={{ fontSize: '1rem', whiteSpace: "nowrap" }}>
        {title}
      </div>
      <div
        className={`display-6 fw-bold ${highlight ? '' : ''}`}
        style={{ fontSize: '2rem', }}
      >
        {value}
      </div>

      {subvalue && (
        <div
          className={`mt-1 fw-normal text-truncate`}
          style={{
            fontSize: '1.6rem',
            color: highlight ? '#EF4444' : '',
            whiteSpace: "nowrap",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          {/* original subvalue (e.g. 'Potential Value: £12,345') */}
          <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{discountedAmount !== null ? `Potential Value:${discountedAmount.toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 })}` :subvalue}</div>

          {/* if a numeric amount exists after 'Potential Value:' show discounted final price */}
          {/* {discountedAmount !== null && (
            <div style={{ fontSize: '1.4rem',marginTop: '4px' }}>
              Final Price: {discountedAmount.toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 })}
            </div>
          )} */}
        </div>
      )}
    </div>
  );
};

export const GaugeChart = ({ percentage, color }) => {
  const value = Math.max(0, Math.min(100, parseFloat(percentage))); // Clamp between 0 and 100
  const radius = 16;
  const circumference = Math.PI * radius; // ~50.265
  const dash = (value / 100) * circumference;

  return (
    <div className="d-flex flex-column align-items-center justify-content-center mb-2" style={{ height: '64px' }}>
      <svg viewBox="0 0 36 18" className="w-100" style={{ height: 'auto' }}>
        <path d="M2 18 A16 16 0 0 1 34 18" fill="none" stroke="#333" strokeWidth="4" />
        <path
          d="M2 18 A16 16 0 0 1 34 18"
          fill="none"
          stroke={color}
          strokeWidth="4"
          strokeDasharray={`${dash} ${circumference - dash}`}
        />
      </svg>
    </div>
  );
};

export const FinancialTarget = ({ title, value, percentage, color, goal, isDark, projected, variance }) => (
  <div
    className={`${isDark ? 'bg-dark text-white border-white' : 'bg-light text-dark border-dark'} h-100 p-3 rounded border d-flex flex-column align-items-center justify-content-center text-center`}
    style={{ minHeight: '200px', backgroundColor: isDark ? '#000' : '#fff' }}
  >
    <div className="h5 fw-semibold text-uppercase mb-3" style={{ color }}>
      {title}
    </div>
    <div className="w-100 d-flex justify-content-center">
      <GaugeChart percentage={percentage.replace("Completed ", "").replace("%", "")} color={color} />
    </div>
    <div className="display-5 fw-bold mb-2" style={{ color, fontSize: '1.75rem' }}>
      {value}
    </div>
    <div className="mb-1" style={{ fontSize: '1.3rem' }}>{percentage}</div>
    <div className={`${isDark ? 'text-white' : 'text-dark'} small`} style={{ fontSize: '1.3rem' }} >{goal}</div>
    <div className="mb-1" style={{ fontSize: '1.3rem' }}>{projected}</div>
    <div className={`small`} style={{ fontSize: '1.3rem',color:'#EF4444' }} >{variance}</div>
  </div>
);

const SectionTitle = ({ children, isDark }) => (
  <h2 className={`${isDark ? 'text-white border-secondary' : 'text-dark border-dark'} h4 fw-semibold  text-uppercase text-center mb-4`}
    style={{ letterSpacing: '0.15em' }}>
    {children}
  </h2>
);

const ThemeToggle = ({ isDark, onToggle }) => (
  <div className="position-fixed top-0 end-0 m-4" style={{ zIndex: 1000, display: "none" }}>
    <button
      style={{ border: "none", background: "none" }}
      onClick={onToggle}
    >
      {isDark ? (
        <>
          <i className="fas fa-sun me-2" style={{ color: "white" }}></i>
        </>
      ) : (
        <>
          <i className="fas fa-moon me-2" ></i>
        </>
      )}
    </button>
  </div>
);

export default function Dashboardv2({ data, totalRefund, financialData, openTickets }) {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const navigate = useNavigate(); // <-- ADD THIS
  const handleLogout = () => {
    // localStorage.removeItem("authToken");   // remove token
    localStorage.removeItem("username");
    localStorage.removeItem("password");
    localStorage.removeItem("role");
    navigate("/");                     // redirect to login page
  };


  return (
    <div
      className={`${isDarkMode ? 'bg-dark text-white' : 'bg-light text-dark'} p-4`}
      style={{
        minHeight: '100vh',
        backgroundColor: isDarkMode ? '#000' : '#f8f9fa',
        transition: 'all 0.3s ease'
      }}
    >

      {/* ---------- ADVANCED HEADER ---------- */}



      <div className="container-fluid">
        {/* Bootstrap CSS and Font Awesome CDN */}
        <link
          href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
          rel="stylesheet"
        />
        <link
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
          rel="stylesheet"
        />
        <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/js/bootstrap.bundle.min.js"></script>


        <ThemeToggle isDark={isDarkMode} onToggle={toggleTheme} />

        <div className="mb-1">
          <SectionTitle isDark={isDarkMode}>Customer Services Department</SectionTitle>
        </div>

        {/* Top Summary */}
        <div className="row g-1 mb-5">
          {data?.cards?.map((item, index) => (
            <div key={index} className="col-12 col-sm-2 col-lg-2 ">
              <DashboardCard
                title={item.title}
                value={item.value}
                subvalue={item.subvalue}
                isDark={['Waiting for Parts', 'Awaiting Collection', 'Awaiting Payment', 'Waiting On Customer', 'Needs Quoting'].includes(item.title) ? false : isDarkMode}
                highlight={true}
              />
            </div>
          ))}
        </div>

        <div className="mb-4">
          <SectionTitle isDark={isDarkMode}>FINANCIAL TARGETS & PROJECTIONS</SectionTitle>
        </div>
        <div className="row g-4">

          <div className="col-12 col-lg-8">
            <div className="row g-1">
              {financialData && financialData?.map((item) => (
                <div className="col-12 col-sm-6 col-xl-3" key={item.id}>
                  <FinancialTarget
                    title={item.Period.toUpperCase()}
                    value={item.Period?.toLowerCase() != "this year" ? `£${data?.progressCards[item?.id - 1]?.value.toFixed()}` : `£${item.Value.toLocaleString()}` }
                    percentage={ item.Period?.toLowerCase() != "this year" ? `Completed ${((data?.progressCards[item?.id - 1]?.value.toFixed()/item.Target)*100).toFixed(2)}%` : `Completed ${item.Completed.toFixed(2)}%`}
                    color={item.Color}
                    goal={`Target £${item.Target.toLocaleString()}`}
                    isDark={isDarkMode}
                    projected={
                      item.Period?.toLowerCase() === "this year" || item.Period?.toLowerCase() === "this month"
                        ? `Projected ${Number(item?.["Projected Month"]) < 0
                          ? `-£${Math.abs(Number(item?.["Projected Month"])).toLocaleString("en-UK")}`
                          : `£${Number(item?.["Projected Month"]).toLocaleString("en-UK")}`}`
                        : false
                    }

                    variance={
                      item.Period?.toLowerCase() === "this year" || item.Period?.toLowerCase() === "this month"
                        ? `Variance ${Number(item?.Variance) < 0
                          ? `-£${Math.abs(Number(item?.Variance)).toLocaleString("en-UK")}`
                          : `£${Number(item?.Variance).toLocaleString("en-UK")}`}`
                        : false
                    }

                  />
                </div>
              ))}
            </div>
          </div>

          <div className="col-12 col-lg-4">
            <div className="row ">
              <div className="col-12 h-100">
                <div
                  className={`${isDarkMode ? 'bg-dark border-white' : 'bg-light border-dark'} border  overflow-hidden`}
                  style={{ backgroundColor: isDarkMode ? '#000' : '#fff', borderRadius: "5px" }}
                >
                  <table className={`table ${isDarkMode ? 'table-dark' : 'table-light'} table-bordered text-center mb-0`}>
                    <thead>
                      <tr style={{ fontSize: '1.2rem' }}>
                        <th className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>Month to Date</th>
                        <th className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>Projected Month</th>
                        <th className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>Variance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{ fontSize: '1.5rem' }}>
                        {financialData[2] && (<><td className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>{`£${financialData[2]['Month to Date'].toLocaleString()}`}</td>
                          <td className={`p-3 fw-semibold ${isDarkMode ? 'border-secondary' : 'border-dark'}`}>{`£${financialData[2]['Projected Month'].toLocaleString()}`}</td>
                          <td
                            className={`p-3 text-danger fw-bold ${isDarkMode ? "border-secondary" : "border-dark"
                              }`}
                          >
                            {Number(financialData[2]["Variance"]) < 0
                              ? `-£${Math.abs(Number(financialData[2]["Variance"])).toLocaleString("en-UK")}`
                              : `£${Number(financialData[2]["Variance"]).toLocaleString("en-UK")}`}
                          </td>
                        </>)}
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>

              <div className="col-12 h-100 " style={{ borderTop: "none", borderRadius: "5px" }}>
                <div
                  className={`${isDarkMode ? 'bg-dark border-white text-white' : 'bg-light border-dark text-dark'} border  border-top-0`}
                  style={{ backgroundColor: isDarkMode ? '#000' : '#fff', display: "flex", justifyContent: "space-around", alignItems: "center", borderRadius: "5px" }}
                >
                  <div className="py-4 px-5" style={{ borderRight: isDarkMode ? '1px solid #fff' : '1px solid #000' }}>
                    <h5 className="h5 fw-semibold mb-1 text-center">TOTAL OPEN TICKET</h5>
                    <p className="text-danger fw-bold mb-0 text-center" style={{ fontSize: '1.8rem' }}>
                      {openTickets?.count}
                    </p>
                  </div>
                  <div className="p-2">
                    <h5 className="h5 fw-semibold mb-1 text-center">PROJECTED VALUE OF TICKETS</h5>
                    <p className="text-danger fw-bold mb-0 text-center" style={{ fontSize: '1.8rem' }}>
                      {/* {openTickets?.value} */}
                      {openTickets?.value && typeof openTickets.value === 'string' && openTickets.value.includes('£') && (
                        (() => {
                          const numeric = parseFloat(openTickets.value.replace(/[^0-9.-]+/g, ''));
                          if (!isNaN(numeric)) {
                            const discounted = numeric * 0.8;
                            return (
                               discounted.toLocaleString('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 })
                            );
                          }
                          return null;
                        })()
                      )}
                    </p>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>
    </div>
  );
}
